import { render, staticRenderFns } from "./SPCompanyInfo.vue?vue&type=template&id=8ffdfb54&scoped=true"
import script from "./SPCompanyInfo.vue?vue&type=script&lang=js"
export * from "./SPCompanyInfo.vue?vue&type=script&lang=js"
import style0 from "./SPCompanyInfo.vue?vue&type=style&index=0&id=8ffdfb54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffdfb54",
  null
  
)

export default component.exports